import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  subCategoryNameVirtualClassrooms: null, 
  itemName: null, 
  dataCardVirtualClassrooms: [], // virtual classroom data
  dataCardEngines: [], // engines data
  subCategoryNameEngines: null, // engines subcategory name
};

export const virtualClassroomOrEnginesSlice = createSlice({
  name: "virtualClassroomOrEngines",
  initialState,
  reducers: {
    setData: (state, action) => {
      const { dataCardVirtualClassrooms, dataCardEngines } = action.payload; 
      state.dataCardVirtualClassrooms = dataCardVirtualClassrooms || state.dataCardVirtualClassrooms;
      state.dataCardEngines = dataCardEngines || state.dataCardEngines;
    },
    setsubCategoryNameOrItemName: (state, action) => {
      const { subCategoryNameVirtualClassrooms, itemName, subCategoryNameEngines } = action.payload;
      if (subCategoryNameVirtualClassrooms) {
        state.subCategoryNameVirtualClassrooms = subCategoryNameVirtualClassrooms;
      } else if (itemName) {
        state.itemName = itemName;
      } else if(subCategoryNameEngines) {
        state.subCategoryNameEngines = subCategoryNameEngines;
      }
    },
  },
});

export const { setData, setsubCategoryNameOrItemName } = virtualClassroomOrEnginesSlice.actions;
export default virtualClassroomOrEnginesSlice;